//登録銘柄の計算に使用
export const calcContractPrice: (
  price: number,
  qty: number,
  rate: number
) => number | null = (price, qty, rate = 1) => {
  if (
    typeof price === "number" &&
    typeof qty === "number" &&
    typeof rate === "number"
  ) {
    return price * qty * rate
  } else {
    return null
  }
}

export const calcEvaluateProfit: (
  price: number | string,
  qty: number | string,
  rate: number | string,
  buyPrice: number | string,
  buyRate: number | string
) => number | null = (price, qty, rate = 1, buyPrice, buyRate) => {
  if (
    typeof price === "number" &&
    typeof qty === "number" &&
    typeof rate === "number" &&
    typeof buyPrice === "number" &&
    typeof buyRate === "number"
  ) {
    const contract = buyPrice * qty * buyRate
    const evaluate = price * qty * rate
    return evaluate - contract
  } else {
    return null
  }
}
